
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MainArval from "../components/MainArval";
import PopUp from "../components/PopUpCTA";

import { Helmet } from "react-helmet-async";

const Arval = () => {
    return (
        <div>
            <Helmet>
                <title>Arval - Carrozzeria Bulletti</title>
            </Helmet>
            <Navbar />
            <MainArval />
            <PopUp />
            <Footer />
        </div>
    );
  };
  
  export default Arval;